import UserService from '../services/UserService';

export const getRequest = (URL: string): Promise<any> => {
  return fetch(`${URL}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Content-Encoding': 'gzip',
      'Authorization': `Bearer ${sessionStorage.getItem('token')}`
    },
  }).then(res => {
    if (res.status === 401) {
      UserService.logout();
    }

    return res;
  }).catch(() => {
    console.log(`TypeError: failed to fetch ${URL}`);
  });
};

export const postRequest = (URL: string, payload?: any): Promise<any> => {
  URL = checkPayloadStatus(URL, payload);
  return fetch(`${URL}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Content-Encoding': 'gzip',
      'Authorization': `Bearer ${sessionStorage.getItem('token')}`
    },
    body: JSON.stringify(payload),
  }).then(res => {
    if (res.status === 401) {
      UserService.logout();
    }

    return res;
  }).catch(() => {
    console.log(`TypeError: failed to fetch ${URL}`);
  });
};

export const postFileUploadRequest = (URL: string, payload?: any): Promise<any> => {
  URL = checkPayloadStatus(URL, payload);
  return fetch(`${URL}`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Encoding': 'gzip',
      'Authorization': `Bearer ${sessionStorage.getItem('token')}`
    },
  }).then(res => {
    if (res.status === 401) {
      UserService.logout();
    }

    return res;
  }).catch(() => {
    console.log(`TypeError: failed to fetch ${URL}`);
  });
};

export const HandlerResponse = (resp: any) => {
  if (!!resp && resp.status === 200) {
    const responseClone = resp.clone();
    const jsonPromise = resp.json();

    return jsonPromise.then((data: any) => {
      return data;
    }).catch((error: any) => {

      return responseClone.text().then((textData: string) => {
        return textData;  // Return the plain text data
      }).catch((textError: any) => {
        console.log('Error parsing response as text:', textError);
        return null;
      });
    })
  }

  if (!!resp && resp.status === 401) {
    UserService.logout();
    return null;
  }

  return null;
};



export const putRequest = (URL: string, payload?: any): Promise<any> => {
  URL = checkPayloadStatus(URL, payload);
  return fetch(`${URL}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Content-Encoding': 'gzip',
      'Authorization': `Bearer ${sessionStorage.getItem('token')}`
    },
    body: JSON.stringify(payload),
  }).then(res => {
    if (res.status === 401) {
      UserService.logout();
    }

    return res;
  }).catch(() => {
    console.log(`TypeError: failed to fetch ${URL}`);
  });
};

export const deleteRequest = (URL: string, payload?: any): Promise<any> => {
  URL = checkPayloadStatus(URL, payload);
  return fetch(`${URL}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Content-Encoding': 'gzip',
      'Authorization': `Bearer ${sessionStorage.getItem('token')}`
    },
    body: JSON.stringify(payload),
  }).then(res => {
    if (res.status === 401) {
      UserService.logout();
    }

    return res;
  }).catch(() => {
    console.log(`TypeError: failed to fetch ${URL}`);
  });
};

export const checkPayloadStatus = (URL: string, payload?: any) => {
  const stPayload = JSON.stringify(payload);
  if (!!stPayload && process.env.REACT_APP_ENABLE_SECURITY_ENCRYPTION === 'TRUE') {
    URL = URL.indexOf('?') > -1 ? URL + '&withPL=true' : URL + '?withPL=true';
  }

  return URL;
};
